import { f } from './fetch.global';
export const fetch = f;
export const globalFetch = f;
